export const SEARCH_FILTER = 1;
export const SEARCH_SAVED_SEARCHES = 2;
export const SEARCH_SAVED_LIST = 3;

export const TYPE_SAVED_SEARCHES = 1;
export const TYPE_SAVED_LISTS = 2;

export const PEOPLE_TYPE = 1;
export const COMPANY_TYPE = 2;
export const INTENT_TYPE = 4;
export const EMPLOYEE_TYPE = 5;
export const SEQUENCE_PROSPECT_TYPE = 6;
export const COMPANY_TRENDING_TYPE = 7;
export const SIMILAR_COMPANY_TYPE = 8;

export const PAGE_MAP = {
  [COMPANY_TYPE]: "company",
  [PEOPLE_TYPE]: "people",
  [INTENT_TYPE]: "intent",
  [EMPLOYEE_TYPE]: "intentEmployee",
  [SEQUENCE_PROSPECT_TYPE]: "sequence",
  [COMPANY_TRENDING_TYPE]: "company",
};

export const TYPE_ADD = 1;
export const TYPE_EDIT = 2;

export const SAVED_LIST_SAVE = 1;
export const SAVED_LIST_UNSAVE = 2;

export const PAGE_SELECT_ALL = 1;
export const PAGE_SELECT_THIS_PAGE = 2;
export const PAGE_SELECT_THIS_CUSTOMIZE = 3;

export const REDEEM_EMAIL = 1;
export const REDEEM_PHONE = 2;
export const REDEEM_EMAIL_AND_PHONE = 3;

export const SAVED_LIST_ADD = "add";
export const SAVED_LIST_DELETE = "delete";

export const CATEGORY_ALL = "filterAll";
export const CATEGORY_MY = "filterPrivate";
export const CATEGORY_TEAM = "filterTeam";

export const categoryMap = new Map([
  [CATEGORY_ALL, null],
  [CATEGORY_MY, true],
  [CATEGORY_TEAM, false],
]);

export const FILTER_REMOVED = "filterRemoved";

export const ERROR_DEFAULT_EMPTY = 1;
export const ERROR_TIMEOUT = 2;
export const ERROR_SEARCH_EMPTY = 3;

export const RECENT_SEARCHES = 1;
export const RECENT_SAVED_FILTERS = 2;

export const TOOLBAR_SEQUENCE = 1;
export const TOOLBAR_SAVED_LIST = 2;

export const NO_LOGO_URL = "/images/no-logo.png";
